'use client';

import { useEffect, useRef } from 'react';

import { toast } from '@/libs/toast';
import {
  fetchServerVersion,
  isVersionSkew,
  LOADED_VERSION,
  logVersionSkew,
  VERSION_CHECK_THROTTLE_MS,
} from '@/utils/versionSkew';

export function VersionSkewWatcher() {
  const isStaleRef = useRef(false);
  const lastCheckRef = useRef(0);

  useEffect(() => {
    if (!LOADED_VERSION) return;

    const controller = new AbortController();

    const checkVersion = async () => {
      if (isStaleRef.current) return;
      if (globalThis.document.visibilityState !== 'visible') return;

      const now = Date.now();
      if (now - lastCheckRef.current < VERSION_CHECK_THROTTLE_MS) return;
      lastCheckRef.current = now;

      const serverVersion = await fetchServerVersion(controller.signal);
      if (!serverVersion || !isVersionSkew(LOADED_VERSION, serverVersion)) return;

      isStaleRef.current = true;
      logVersionSkew(serverVersion);

      toast.warning('Nova versão disponível', {
        description: 'Recarregue a página para continuar.',
        action: {
          label: 'Recarregar',
          onClick: () => globalThis.location.reload(),
        },
        duration: Infinity,
      });
    };

    const onVisibilityChange = () => {
      void checkVersion();
    };

    const onPageShow = () => {
      void checkVersion();
    };

    globalThis.document.addEventListener('visibilitychange', onVisibilityChange);
    globalThis.addEventListener('pageshow', onPageShow);

    return () => {
      controller.abort();
      globalThis.document.removeEventListener('visibilitychange', onVisibilityChange);
      globalThis.removeEventListener('pageshow', onPageShow);
    };
  }, []);

  return null;
}
